import React from 'react';
import ProjectCard from './ProjectCard';
import '../styles/SelectedProjects.css';

const projects = [
    {
        year: '2024',
        title: "Digitizing LagosRaCs' Range of Rental Services",
        description: 'Designed and developed a responsive website for a car rental business based in Dubai, \n' +
            'integrating real-time vehicle availability, user-friendly reservation interface, and payment processing . Over 100,000 transactions.',
        tags: 'Website, Admin, FullStack',
        image: '/images/project1.png', // Replace with your actual image path
    },
    {
        year: "2024",
        title: "Application’s User Interface – Client Project",
        description: "Collaborated with a cross-functional team to design and develop a mobile version of an existing web application for iOS. Created responsive and interactive components in Swift, focusing on touch gestures, animations, accessible menus, and transitions aligned with iOS design standards. Led the UI/UX design process with Figma, from wireframes to high-fidelity mockups, while iterating based on usability testing and user feedback.",
        tags: 'Figma", "Swift", "UI/UX Design", "Mobile Development", "iOS Design Standards", "Prototyping", "Usability Testing',
        image: ""
    },
    {
        year: "2023",
        title: "Weather Dashboard - Project Development Hub",
        description: "Designed and developed a weather dashboard tool that fetches and displays real-time data for temperature, humidity, visibility, air pressure, wind direction, wind speed, and dew point. Ensured responsive design, cross-browser compatibility, and incorporated API error handling with intuitive loading indicators for smooth user experience.",
        tags: 'WeatherKit REST API", "React", "CSS", "Figma", "Lead Designer", "Real-Time Applications", "Cross-Browser Compatibility',
        image: '/images/project2.png', // Replace with your actual image path
    },
    {
        year: '2021',
        title: 'Streamlined Documentation Platform',
        description: 'Developed a centralized platform for mobile, web, and documentation.',
        tags: 'Web, Mobile, Documentation',
        image: '/images/project3.png', // Replace with your actual image path
    },
    // {
    //     year: '2010',
    //     title: 'Streamlined Documentation Platform',
    //     description: 'Developed a centralized platform for mobile, web, and documentation.',
    //     tags: 'Web, Mobile, Documentation',
    //     image: '/images/project3.png', // Replace with your actual image path
    // },
];

const SelectedProjects = () => {
    return (
        <section id="selected-projects" className="selected-projects">
            <h2 className="section-title">Selected Projects</h2>
            <div className="project-cards">
                {projects.map((project, index) => (
                    <ProjectCard
                        key={index}
                        year={project.year}
                        title={project.title}
                        description={project.description}
                        tags={project.tags}
                        image={project.image}
                    />
                ))}
            </div>
        </section>
    );
};

export default SelectedProjects;